var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEmail(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 17,
    viewBox: "0 0 20 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 16.75H4C1.582 16.75 0.25 15.418 0.25 13V4C0.25 1.582 1.582 0.25 4 0.25H16C18.418 0.25 19.75 1.582 19.75 4V13C19.75 15.418 18.418 16.75 16 16.75ZM4 1.75C2.423 1.75 1.75 2.423 1.75 4V13C1.75 14.577 2.423 15.25 4 15.25H16C17.577 15.25 18.25 14.577 18.25 13V4C18.25 2.423 17.577 1.75 16 1.75H4ZM11.0291 9.179L15.9409 5.60699C16.2759 5.36399 16.35 4.89401 16.106 4.55901C15.863 4.22501 15.3951 4.149 15.0581 4.394L10.146 7.966C10.058 8.03 9.94103 8.03 9.85303 7.966L4.94092 4.394C4.60292 4.149 4.13607 4.22601 3.89307 4.55901C3.64907 4.89401 3.72311 5.36299 4.05811 5.60699L8.96997 9.17999C9.27797 9.40399 9.63902 9.515 9.99902 9.515C10.359 9.515 10.7221 9.403 11.0291 9.179Z",
    fill: "#25314C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail);
export default __webpack_public_path__ + "static/media/email.d740acb455efeec13c46119cd1e4d5b0.svg";
export { ForwardRef as ReactComponent };